import { SVGProps } from "react";
const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.33398 6.43767V3H14.6673V6.43767C13.9612 6.68933 13.4552 7.36843 13.4552 8.16667C13.4552 8.9649 13.9612 9.644 14.6673 9.89567V13.3333H1.33398V9.89567C2.04016 9.644 2.5461 8.9649 2.5461 8.16667C2.5461 7.36843 2.04016 6.68933 1.33398 6.43767Z"
      fill="url(#paint0_linear_75_6318)"
      stroke="url(#paint1_linear_75_6318)"
      strokeWidth={0.666667}
      strokeLinejoin="round"
    />
    <path
      d="M6.33398 5.3335L8.00065 7.00016L9.66732 5.3335"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 7.3335H10"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 9.38867H10"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 7.3335V11.3335"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_75_6318"
        x1={13.2027}
        y1={3}
        x2={2.79856}
        y2={13.3333}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F03C3D" />
        <stop offset={1} stopColor="#EBC62F" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_75_6318"
        x1={13.1643}
        y1={3}
        x2={2.83701}
        y2={13.3333}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EF4E3B" />
        <stop offset={1} stopColor="#EBBC30" />
      </linearGradient>
    </defs>
  </svg>
);
export default SVGComponent;
